import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '../../../../node_modules/@angular/router';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { MatSnackBar } from '../../../../node_modules/@angular/material';
import { LoggingService } from '../../services/logging-service/logging.service';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { HttpErrorResponse } from '@angular/common/http';
import { HomeCardService } from '../../services/home-card-service/home-card.service';
import { HomeCardModel } from '../../models/home-card-model';


@Component({
  selector: 'app-portal-home-view',
  templateUrl: './portal-home-view.component.html',
  styleUrls: ['./portal-home-view.component.css']
})
export class PortalHomeViewComponent implements OnInit {

  loaded: boolean;
  error: boolean;
  patient: any;
  booked: boolean;

  private trustCardSubscription: Subscription;

  aboutMe: HomeCardModel;
  contact: HomeCardModel;
  logout: HomeCardModel;
  myBirthPlan: HomeCardModel;
  myNotes: HomeCardModel;
  myPregnancyAndMe: HomeCardModel;

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private patientData: PatientDataService,
    private loggingService: LoggingService, private snackBar: MatSnackBar,
    private userSession: UserSessionService, private trustDataService: TrustDataService,
    private homeCardService: HomeCardService) { }

  ngOnInit() {

    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, 'Hi, ' + this.appConfigService.Forename, null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));

    // Get all of the homecard configuration from the service    


    this.homeCardService.loadHomeCards();
    this.homeCardService.cardsReady.subscribe(x => {
      console.log("Finding Home Cards");
      this.aboutMe = this.userSession.homeCards.find(x => x.CardName === 'AboutMe');
      this.contact = this.userSession.homeCards.find(x => x.CardName === 'Contact');
      this.logout = this.userSession.homeCards.find(x => x.CardName === 'Logout');
      this.myBirthPlan = this.userSession.homeCards.find(x => x.CardName === 'MyBirthPlan');
      this.myPregnancyAndMe = this.userSession.homeCards.find(x => x.CardName === 'MyPregnancyAndMe');
      this.myNotes = this.userSession.homeCards.find(x => x.CardName === 'MyNotes');
      this.loaded = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-home-view/portal-home-view.component.ts